import { Component, OnDestroy, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-add-edit-delete-action-renderer',
  template: `
    <style>
      .edit-btn {
        color: white;
        background: #3aafe4;
      }
      .del-btn {
        color: white;
        background: red;
      }
      i {
        color: white;
      }
      .btn:disabled {
        opacity: 0.5;
      }
      .btn {
        border: none;
        border-radius: 20px;
        cursor: pointer;
      }
      button{
        width: 35px;
        height: 35px;
      }
    </style>
    <div style="display:flex;align-items: center;justify-content: space-between;">
      <button
        tooltipPosition="top"
        pTooltip="Add Action"
        mat-mini-fab
        color="accent"
        (click)="onClick($event)"
        class="add-icon"
      >
        <mat-icon style="line-height: 20px">add</mat-icon>
      </button>
      <button
        class="edit-btn btn"
        [disabled]="!this.params.data.IsWrite"
        mat-icon-button
        (click)="onClickEdit($event)"
      >
        <i class="fa fa-pencil-square-o" aria-hidden="true" style="font-size: 18px"></i>
      </button>

      <button
        class="del-btn btn"
        [disabled]="!this.params.data.IsWrite"
        mat-icon-button
        (click)="onClickDelete($event)"
      >
        <i class="fa fa-trash" aria-hidden="true" style="font-size: 18px"></i>
      </button>
    </div>
  `,
  styles: [
    `
      .add-icon {
        background: cornflowerblue;
      }
    `,
  ],
})
export class AddEditDeleteActionRendererComponent
  implements ICellRendererAngularComp, OnDestroy
{
  params: any;
  refresh(params: any): boolean {
    throw new Error('Method not implemented.');
  }

  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClick(params);
    }
  }
  onClickEdit($event: any): any {
    if (this.params.onClickEdit instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClickEdit(params);
    }
  }
  onClickDelete($event: any): any {
    if (this.params.onClickDelete instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        index: this.params.node.rowIndex,
        // ...something
      };
      this.params.onClickDelete(params);
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
